import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';

@Injectable()
export class LocalizedPageTitleStrategy extends TitleStrategy {
  constructor(
    private translate: TranslateService,
    private readonly title: Title
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);

    if (title !== undefined) {
      combineLatest([
        this.translate.get(title),
        this.translate.get('ApplicationName'),
      ]).subscribe(([translatedTitle]) => {
        this.title.setTitle(translatedTitle + ' | Blum-Novotest GmbH');
      });
    }
  }
}
